
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import serviceWorker from '../Other/serviceWorker';
import '../Other/index.css';

ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();
